import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { State } from "redux/state";

import {
    SidebarNavMenuView,
    SidebarNavMenuViewOwnProps as OwnProps,
    SidebarNavMenuViewStateProps as StateProps,
} from "../components/SidebarNavMenuView";

const mapDispatchToProps: MapDispatchToProps<{}, OwnProps> = (dispatch: Dispatch) => {
    return {};
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    asUser: state.auth.asUser,
    org: state.org.currentOrg ? state.org.currentOrg : undefined,
    user: state.auth.profile
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SidebarNavMenuView)
);
